import {
  Flex, Icon, IconButton, Text, Box, Spacer,
  Menu, MenuButton, Tooltip,
} from "@chakra-ui/react";
import {
  MdChevronRight,
  MdEdit,
  MdDelete,
} from "react-icons/md";
import { FcFolder, FcOpenedFolder } from "react-icons/fc";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaFolderPlus } from "react-icons/fa";

export default function Folder({ 
  Item, 
  OnSelect, 
  OnChange, 
  OnToggleFolder, 
  OpenFolders, 
  Selected, 
  level = 0, 
  RenderFolders,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  
  const isOpen = !!OpenFolders[Item.FolderId];
  const isSelected = Selected === Item.FolderId;
  const hasChildren = Item.Children && Item.Children.length > 0;
  const paddingLeft = `${level * 20 + 5}px`;

  return (
    <Box pl={paddingLeft} sx={{ color: 'var(--fm-folder-text)'}}>
      <Flex
        align="center"
        w="100%"
        p={1.5}
        borderRadius="md"
        cursor="pointer"
        onClick={() => OnSelect(Item)}
        title={Item.FolderName}
        className="folder-item"
        sx={{
          bg: isSelected ? '#rgba(52, 51, 51, 0)' : '#rgba(52, 51, 51, 0)',
          _hover: { 
            bg: isSelected ? '#rgba(52, 51, 51, 0)' : 'rgba(52, 51, 51, 0)' 
          }
        }}
      >
        <IconButton
          icon={<MdChevronRight />}
          variant="ghost"
          size="sm"
          aria-label={fileManagerTexts.ariaLabels?.toggleChildren || "Toggle children"}
          transform={isOpen ? "rotate(90deg)" : "none"}
          transition="transform 0.2s"
          onClick={(e) => {
            e.stopPropagation();
            OnToggleFolder(Item.FolderId);
          }}
          visibility={hasChildren ? "visible" : "hidden"}
          sx={{
            color: 'var(--fm-folder-icon-color)',
            _hover: { 
              color: 'var(--fm-folder-icon-hover-color)',
              bg: 'rgba(52, 51, 51, 0)'
            }
          }}
        />
        
        <Icon 
          as={isOpen ? FcOpenedFolder : FcFolder} 
          boxSize="1.5rem" 
          mx={1} 
        />
        
        <Tooltip label={Item.FolderName} placement="top-start" openDelay={500}>
          <Text noOfLines={1} fontSize="sm">{Item.FolderName}</Text>
        </Tooltip>

        <Spacer />

      </Flex>
      
      {isOpen && hasChildren && (
        <Box>
          {RenderFolders(Folder, Item.Children, { 
            OnSelect, 
            OnChange, 
            OnToggleFolder, 
            OpenFolders, 
            Selected, 
            level: level + 1,
            texts 
          })}
        </Box>
      )}
    </Box>
  );
}